<template>
  <div class="skeleton-container">
    <div class="user_section user_info">
      <div class="skeleton-avatar"></div>
      <div class="user_info_content">
        <div class="skeleton-name"></div>
        <div class="skeleton-count-wrapper">
          <div class="skeleton-count"></div>
          <div class="skeleton-count"></div>
        </div>
      </div>
      <div class="skeleton-action-btn"></div>
    </div>

    <div class="user_section">
      <div class="skeleton-score"></div>
      <div class="skeleton-action-btn-right"></div>
    </div>

    <div class="user_section">
      <div class="skeleton-tip-icon"></div>
      <div class="skeleton-tip"></div>
    </div>
  </div>
</template>

<script setup></script>

<style scoped>
.skeleton-container {
  max-width: 760px;
  margin: 0 auto;
  padding: 80px 0 100px;
}

.user_section {
  margin: 30px auto;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.05);
  padding: 30px;
  position: relative;
  width: 760px;
  display: flex;
  align-items: center;
}

.user_info {
  display: flex;
  width: 100%;
}

.skeleton-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-right: 20px;
}

.user_info_content {
  flex: 1;
}

.skeleton-name {
  width: 160px;
  height: 24px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 10px;
  border-radius: 4px;
}

.skeleton-count-wrapper {
  display: flex;
  align-items: center;
  gap: 24px;
}

.skeleton-count {
  width: 80px;
  height: 18px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

.skeleton-action-btn {
  width: 160px;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-left: auto;
  border-radius: 4px;
}

.skeleton-action-btn-right {
  width: 120px;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  position: absolute;
  right: 30px;
  border-radius: 4px;
}

.skeleton-score {
  width: 240px;
  height: 24px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

.skeleton-tip-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-right: 20px;
  border-radius: 4px;
}

.skeleton-tip {
  flex: 1;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* 手机端（≤640px）：与 userCenter.vue 的媒体查询保持一致，卡片不再固定 760px */
@media (max-width: 640px) {
  .skeleton-container {
    box-sizing: border-box;
    /* 顶部与真实页一致，给贴卡片的 switch 页签留空间 */
    padding: 96px 12px 40px;
  }

  .user_section {
    box-sizing: border-box;
    width: auto;
    margin: 0 auto 16px;
    padding: 18px 16px;
    flex-wrap: wrap;
  }

  .skeleton-avatar {
    width: 40px;
    height: 40px;
    margin-right: 12px;
    flex-shrink: 0;
  }

  .user_info_content {
    min-width: 0;
  }

  .skeleton-name {
    width: 60%;
    max-width: 160px;
    height: 18px;
  }

  .skeleton-count-wrapper {
    gap: 16px;
  }

  .skeleton-count {
    width: 64px;
    height: 16px;
  }

  /* 右侧操作按钮在手机上独占一行并加分隔线 */
  .skeleton-action-btn,
  .skeleton-action-btn-right {
    position: static;
    width: 100%;
    height: 16px;
    margin: 14px 0 0;
    padding-top: 14px;
    border-top: 1px solid rgba(5, 100, 79, 0.1);
  }

  .skeleton-score {
    width: 60%;
    height: 20px;
  }

  .skeleton-tip-icon {
    width: 40px;
    height: 40px;
    margin-right: 12px;
    flex-shrink: 0;
  }

  .skeleton-tip {
    min-width: 0;
  }
}
</style>
